<template>
    <div class="flex">
        <UserAvatar
            is-anonymous
            size="xs"
        />
        <NsfwText
            lang-path="post:nsfw.comment"
            class="ml-2"
        ></NsfwText>
    </div>
</template>

<script>
import NsfwText from './NsfwText.vue';

export default {
    name: 'PostCommentNsfw',
    components: {
        NsfwText,
    },
};
</script>
